import {useEffect, useState} from 'react';
import {config} from '../environment';
import {EventStatistics, EventStatisticsResponse} from '../types/vwCelebration';
import {GPSTourBrandExperiences} from '../constants';

type Props = {
  gpsTourBranch?: GPSTourBrandExperiences;
};

export const useFetchVWCelebrationStatistics = ({gpsTourBranch}: Props) => {
  const [data, setData] = useState<EventStatistics>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!gpsTourBranch) {
      return;
    }

    const fetchData = async () => {
      try {
        const data: EventStatisticsResponse = await fetch(
          `${config.API_VW_CELEBRATION_EVENT_STATISTIC}?branch=${gpsTourBranch}`,
        ).then((res) => res.json());

        setData(data.statistics);
      } catch (error) {
        console.error('Error fetching event statistic', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [gpsTourBranch]);

  return {data, loading};
};
